export default __webpack_public_path__ + "static/media/photo-task.b5fb43be.svg";